import { Link } from 'react-router-dom';
import { MessageSquare, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { MockJobPositionAI } from './MarketingProductMocks';
import { useLanguage } from '@/contexts/LanguageContext';

export function MarketingAssistantBand() {
  const { t } = useLanguage();

  return (
    <section className="container py-16 md:py-20">
      <div className="grid lg:grid-cols-2 gap-10 items-center">
        <div className="space-y-5 order-2 lg:order-1">
          <div className="flex items-center gap-2 text-brand-accent">
            <MessageSquare className="h-6 w-6" aria-hidden />
            <span className="text-sm font-medium">{t('marketing.assistant.badge')}</span>
          </div>
          <h2 className="font-display font-bold text-2xl md:text-3xl tracking-tight">
            {t('marketing.assistant.title')}
          </h2>
          <p className="text-muted-foreground leading-relaxed">{t('marketing.assistant.lead')}</p>
          <ul className="space-y-2 text-sm text-muted-foreground">
            {(['marketing.assistant.b1', 'marketing.assistant.b2', 'marketing.assistant.b3'] as const).map((key) => (
              <li key={key} className="flex gap-2 leading-relaxed items-start">
                <Check className="h-4 w-4 text-brand-accent shrink-0 mt-0.5" aria-hidden />
                {t(key)}
              </li>
            ))}
          </ul>
          <Button className="bg-brand-accent hover:bg-brand-accent/90" asChild>
            <Link to="/signup">{t('marketing.hero.ctaTrial')}</Link>
          </Button>
        </div>
        <div className="order-1 lg:order-2">
          <MockJobPositionAI />
        </div>
      </div>
    </section>
  );
}
